import CardCommon from '@/pages/opinion/components/CardCommon';
import { getLookerSignedUrl } from '@/pages/opinion/services';
import React, { useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import { connect, useParams } from 'umi';
import './index.scss';
import {
  DBO_POINT,
  useInitBuriedPointInfo,
} from '@op/operationLog/buriedPoint';
import { LookerReportPoint } from '@op/operationLog/pages';
import usePageName from '@op/hooks/usePageName';
const { Content } = Layout;

function LookReport({ gameInfo, listMenu }: any) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const { lookerId } = useParams<{ lookerId: string }>();

  const { pageName } = usePageName({ menuId: lookerId, listMenu });

  useInitBuriedPointInfo({
    buriedPoint: LookerReportPoint(pageName, location.pathname),
    triggerPagePoint: false,
  });

  useEffect(() => {
    if (!gameInfo.edition_unified_id) return;
    setLoading(true);

    if (!lookerId) return;
    getLookerSignedUrl({
      ext_types: ['looker'],
      menu_id: Number(lookerId),
      edition_unified_id: gameInfo.edition_unified_id,
    })
      .then((data: { looker: any }) => {
        DBO_POINT.page(undefined, pageName);
        setUrl(data?.looker?.looker_url || '');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [gameInfo, lookerId]);

  return (
    <Content className="report-looker-wrapper">
      <CardCommon
        empty={!url}
        className="report-looker-box"
        loading={loading}
        loadingHeight={550}
        emptyHeight={550}
      >
        <iframe src={url} className="iframe-info" />
      </CardCommon>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    listMenu: opinionCommon.listMenu,
  };
})(LookReport);
